import React, { useContext, useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { Box, Paper } from "@mui/material";
import X from "../assets/X.svg";
import O from "../assets/O.svg";
import socket from "../utils/socket";
import { useParams } from "react-router-dom";
import GlobalContext from "../Contexts/GlobalContext";
import isItMyTurn from "../utils/isItMyTurn";

const Item = styled(Box)({
  background: "#9acef8",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const Grid = () => {
  const {
    setRole,
    permanentDisable,
    setPermanentDisable,
    setCheckersCount,
    checkersCount,
    role,
    gameStatus,
    setGameStatus,
    setWinner,
  } = useContext(GlobalContext);
  const { gameId } = useParams("");

  useEffect(() => {
    socket.emit("join-room", gameId);
  }, []);

  socket.on("join-room-ack", (res) => {
    setGameStatus(res.gameStatus);
    setRole(res.role);
    if (res.role === "spectator") setPermanentDisable(true);
  });

  socket.on("updated-checkers", (res) => {
    setCheckersCount(res.count);
    setCheckers(res.checkers);
  });

  socket.on("game-over", (res) => {
    setGameStatus(res.gameStatus);
    setWinner(res.winner);
  });

  socket.on("new-game", (res) => {
    setWinner("");
    setCheckersCount(res.count);
    setCheckers(res.checkers);
    setGameStatus("playing");
    if (!permanentDisable && role !== "spectator") {
      if (role === "player1") setRole("player2");
      else if (role === "player2") setRole("player1");
    }
  });

  const [checkers, setCheckers] = useState([
    [
      {
        type: "",
        disabled: false,
        id: "00",
      },
      {
        type: "",
        disabled: false,
        id: "01",
      },
      {
        type: "",
        disabled: false,
        id: "02",
      },
    ],
    [
      {
        type: "",
        disabled: false,
        id: "10",
      },
      {
        type: "",
        disabled: false,
        id: "11",
      },
      {
        type: "",
        disabled: false,
        id: "12",
      },
    ],
    [
      {
        type: "",
        disabled: false,
        id: "20",
      },
      {
        type: "",
        disabled: false,
        id: "21",
      },
      {
        type: "",
        disabled: false,
        id: "22",
      },
    ],
  ]);

  const placeChecker = (id) => {
    if (!id) return;
    if (
      !permanentDisable &&
      isItMyTurn(checkersCount, role) &&
      gameStatus === "playing"
    )
      socket.emit("place-checker", id);
  };

  const GridItem = (props) => {
    return (
      <Item onClick={() => placeChecker(props.checker.id)}>
        <Paper
          square
          elevation={0}
          sx={{
            display:
              // Only display the paper if X or O is to be shown
              props.checker.type ? "block" : "none",
            background: "none",
          }}
        >
          <img
            className={props.checker.type}
            src={props.checker.type === "x" ? X : O}
            alt=""
          />
        </Paper>
      </Item>
    );
  };

  return (
    <div className="grid-container">
      {checkers.map((row) =>
        row.map((item, index) => <GridItem checker={item} key={index} />)
      )}
    </div>
  );
};

export default Grid;
